import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Input } from '@components/Input';
import { Switch } from '@components/Switch';
import { ModalBase } from '@components/Modal';
import { inboxTemplatesService } from '@services';
import { parseTipTapJSONToPlainText } from '@helpers/text-editor';
import { alertActions, inboxTemplatesActions } from '@actions';
import { useTranslation } from '@hooks';
import { ROLE } from '@constants/user';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 500,
        '@media (max-width: 600px)': {
            width: 'calc(100% - 32px)',
        },
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

const CreateTemplateModal = ({ user, content, setAnchorElEdit, isCreateModalOpen, setCreateModalOpen }) => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [shared, setShared] = useState(user.role !== ROLE.USER);
    const dispatch = useDispatch();

    const onCreateTemplate = async () => {
        try {
            await inboxTemplatesService.addOrUpdateInboxTemplate({
                name,
                authorName: `${user.firstName} ${user.lastName}`,
                message: parseTipTapJSONToPlainText(content),
                shared,
            });
            dispatch(alertActions.success(t('alertMessages.createSuccess')));
            await dispatch(inboxTemplatesActions.getAll());
        } catch (error) {
            dispatch(alertActions.error(t('alertMessages.createFail')));
        }
        setName('');
        setCreateModalOpen();
        setAnchorElEdit(null);
    };

    return (
        <Modal
            isOpen={isCreateModalOpen}
            handleClose={() => setCreateModalOpen(false)}
            title={t('RespondTemplate.saveNewTemplate')}
            onPrimaryAction={onCreateTemplate}
            primaryActionText={t('buttons.save')}
            primaryActionDisabled={!name || !content}
            onSecondaryAction={() => setCreateModalOpen(false)}
            secondaryActionText={t('buttons.cancel')}
        >
            <Input
                inputProps={{ name: 'name', value: name, onChange: e => setName(e.target.value) }}
                fullWidth
                label={t('common.templateName')}
                required
            />
            <Switch
                checked={shared}
                handleChange={event => setShared(event.target.checked)}
                label={t('InboxTemplates.sharedTemplate')}
                disabled={user.role === ROLE.USER}
            />
        </Modal>
    );
};

export default CreateTemplateModal;
